import { createSelector } from "@reduxjs/toolkit";

const selectNotification = (state) => state.notification;

export const selectNotificationTabs = createSelector(
  [selectNotification],
  (notification) => notification.notificationTabs || "wip"
);

